<template>
  <q-dialog content-class="post-reply-page" v-model="replyData.dialogDisplay" persistent :maximized="maximizedToggle" transition-show="slide-left" transition-hide="slide-right">
    <q-card class="bg-white">
      <q-bar>
        <!-- 讚數 -->
        <div class="great-amount-div">
          <img src="@/assets/img/icon_goodblue.png" />
          <span class="great-amount">{{ replyData.likeCount }} 人都說讚</span>
        </div>
        <!-- 關閉按鈕 -->
        <q-btn dense flat icon="close" v-close-popup @click="closeDialog()">
          <q-tooltip content-class="bg-white text-primary">Close</q-tooltip>
        </q-btn>
      </q-bar>
      <!-- 回覆列表含輸入框 -->
      <PostReplyList v-if="isFinishPostReplyData" :replyListData="replyData"></PostReplyList>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import PostReplyList from '@/components/SharedComponents/PostReplyList';
export default {
  name: 'PostReplyDialog',
  props: ['replyData'],
  components: {
    PostReplyList
  },
  data() {
    return {
      maximizedToggle: true
    };
  },
  computed: {
    ...mapState('PostReplyListModule', ['isFinishPostReplyData']),
    ...mapGetters('PostReplyListModule', ['getPostReplyAllData', 'getPostSortReplyList'])
  },
  watch: {
    replyData() {
      if (this.replyData.dialogDisplay) {
        this.showApiReply(this.replyData.postId);
      }
    }
  },
  methods: {
    ...mapActions('PostReplyListModule', ['showApiReply']),
    // 關閉 dialog
    closeDialog() {
      this.$emit('changeDisplay', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.great-amount-div {
  width: calc(100% - 35px);
  color: $LalePrimary;
  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  .great-amount {
    vertical-align: top;
  }
}
</style>

<!-- 全域的 -->
<style lang="scss">
.post-reply-page {
  .q-bar {
    position: fixed;
    top: 0px;
    width: 100%;
    background-color: #ffffff;
    margin: 0;
    padding: 15px 12px 8px 15px;
    border-bottom: 1px solid #e9ecef !important;
    z-index: 2;
  }

  .q-icon {
    font-size: 28px;
    color: $LaleNotActiveGray;
  }
  .q-bar--standard {
    height: auto;
  }

  .q-card__section {
    height: calc(100% - 120px);
    overflow-y: auto;
    margin-bottom: 80px;
    margin-top: 55px;
  }

  .q-field--filled .q-field__control {
    border-radius: 4px;
  }

  .q-field--filled .q-field__control:before {
    border-bottom: none;
  }

  .q-field--filled.q-field--focused .q-field__control:before {
    opacity: 0.4;
  }
}
</style>
